/**
 * Deactivate globally the plugins for the charts
 */
import Chart from 'chart.js'

Chart.defaults.global.plugins.labels = false
Chart.defaults.global.plugins.zoom = false
